import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomeTurma = (): TabelaColuna => ({
  Chave: 'nomeTurma',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome Turma</div>
})
